import React, { useCallback } from 'react';

import { useDeleteFundRaisingAwaitable, usePostFundRaisingAwaitable } from '../../../services';
import { CartActions, ECartActions, IToggleFundRaisingAction } from '../model';

export const useToggleFundRaising = (dispatch: React.Dispatch<CartActions>) => {
  const { request: deleteFundRaisingRequest } = useDeleteFundRaisingAwaitable();
  const { request: addFundRaisingRequest } = usePostFundRaisingAwaitable();

  return useCallback(
    async (data: IToggleFundRaisingAction) => {
      let fundRaisingData;

      if (data.active) {
        fundRaisingData = (await addFundRaisingRequest())?.data;
      } else {
        fundRaisingData = (await deleteFundRaisingRequest())?.data;
      }

      if (fundRaisingData) {
        dispatch({
          actionType: ECartActions.TOGGLE_FUND_RAISING,
          payload: {
            pricesSummary: fundRaisingData.pricesSummary,
            fundRaising: fundRaisingData.serviceItems.fundRaising,
          },
        });
      }
    },
    [addFundRaisingRequest, deleteFundRaisingRequest, dispatch],
  );
};
